import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function QuickAddPartyModal({
  open,
  onClose,
  onCreated,
  overlayClassName = "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4",
  title = "Quick Add Party",
}) {
  const nameRef = useRef(null);
  const [name, setName] = useState("");
  const [gstin, setGstin] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setTimeout(() => nameRef.current?.focus?.(), 60);
    else { setName(""); setGstin(""); setAddress(""); setPhone(""); setSaving(false); }
  }, [open]);

  const handleCreate = async () => {
    if (!name || !name.trim()) {
      toast.error("Enter customer name");
      return;
    }
    setSaving(true);
    try {
      const docRef = await addDoc(collection(db, "customers"), {
        partyName: name.trim(),
        gstin: gstin.trim(),
        address: address.trim(),
        phone: phone.trim(),
        group: "Sundry Debtors",
        createdAt: serverTimestamp(),
      });
      const newParty = {
        id: docRef.id,
        partyName: name.trim(),
        gstin: gstin.trim(),
        address: address.trim(),
        phone: phone.trim(),
        group: "Sundry Debtors",
      };
      onCreated?.(newParty);
      onClose();
      toast.success("Customer added");
    } catch (err) {
      console.error("Error creating party:", err);
      toast.error(err?.message || "Failed to create customer");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;
  return (
    <div
      className={overlayClassName}
      role="presentation"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-4 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quick-add-party-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-3">
          <div id="quick-add-party-title" className="font-semibold">
            {title}
          </div>
          <button className="text-red-500" onClick={onClose} type="button">Close</button>
        </div>

        <div className="space-y-2 text-sm">
          <label className="block">
            <div className="text-xs">Name</div>
            <input ref={nameRef} value={name} onChange={(e) => setName(e.target.value)} className="w-full border px-2 py-1" />
          </label>
          <label className="block">
            <div className="text-xs">GSTIN</div>
            <input value={gstin} onChange={(e) => setGstin(e.target.value)} className="w-full border px-2 py-1" />
          </label>
          <label className="block">
            <div className="text-xs">Address</div>
            <textarea value={address} onChange={(e) => setAddress(e.target.value)} className="w-full border px-2 py-1" />
          </label>
          <label className="block">
            <div className="text-xs">Phone</div>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full border px-2 py-1" />
          </label>
        </div>

        <div className="mt-3 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 border rounded" type="button">Cancel</button>
          <button onClick={handleCreate} className="px-3 py-1 bg-blue-600 text-white rounded" disabled={saving} type="button">
            {saving ? "Saving..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
